import { useField, useFormikContext } from "formik";
import Input from "../../shared/Input/Input";
import { getNestedValue } from "../../components/PIForm/Steps/step3/utils";
import { InputForm } from "./styles";
export const FormikInput = ({
  name,
  style,
  errorMessage = null,
  inputStyles,
  ...rest
}) => {
  const { touched, errors, values, handleBlur, handleChange } =
    useFormikContext();

  const [field] = useField({ name, ...rest });

  return (
    <InputForm style={style}>
      <label>
        <div className="mb-1"> {rest.label}</div>
        <Input
          name={name}
          id={name}
          style={inputStyles}
          notValid={
            getNestedValue(touched, name) && getNestedValue(errors, name)
          }
          errorMessage={errorMessage || getNestedValue(errors, name)}
          value={getNestedValue(values, name)}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={name}
          {...field}
          {...rest}
        />
      </label>
    </InputForm>
  );
};
